import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from "@angular/router";
import { Injectable } from "@angular/core";
import { LoginService } from "../service/login.service";
import { EnumPerfilUsuario } from "../model/usuario.model";
import { AuthorizeService } from "../service/authorize.service";

@Injectable()
export class RouteCrudAdminGuard implements CanActivate {

    constructor(private loginService: LoginService,
                private authorizeService: AuthorizeService) { }

    canActivate(activatedRoute: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): boolean {
        return this.checkAuthentication()
    }

    checkAuthentication(): boolean {
        const loggedIn = this.loginService.isLoggedIn();
        const usuario = this.loginService.usuario;
        if (!loggedIn) {
            window.location.href = "/";
       }
       const checked = loggedIn &&
       (this.authorizeService.hasPerfil(EnumPerfilUsuario.GESTOR_SISTEMA) ||
        this.authorizeService.hasPerfil(EnumPerfilUsuario.GESTOR_HOSPITAL)
       );
       console.log("check Crud Admin", checked);
        return checked
    }

}